import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { RemoteFetchInputUsageSummary } from "../../../data/usecases/input-utilization/remote-fetch-input-usage-summary";
import { FetchInputUsageSummary } from "../../../domain/useages/input-utilization/fetch-input-usage-summary";
import Endpoints from "../../../domain/endpoints";
import Swal from "sweetalert2";
import { RemoteFetchInputsBasedOnProductType } from "../../../data/usecases/input-utilization/remote-fetch-input-based-on-product-type";
import { FetchInputsBasedOnProductType } from "../../../domain/useages/input-utilization/fetch-inputs-based-on-product-type";
import { InputUBasedOnProductType } from "../../../domain/models/input-utilization/input-based-on-product-type";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchInputsBasedOnProductTypeInterface {
  fetchInputBasedOnProductType: Function;
  inputBasedOnProductTypLoading: FetchState;
  inputBasedOnProductTypeFilters: {
    inputType: string;
  };
  inputBasedOnProductTypeData: InputUBasedOnProductType[];
}

const initialStates = {
  inputBasedOnProductTypLoading: FetchState.DEFAULT,
  inputBasedOnProductTypeFilters: {
    inputType: "",
  },
  inputBasedOnProductTypeData: [],
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchInputsBasedOnProductType: StateCreator<
  FetchInputsBasedOnProductTypeInterface
> = (set, get) => ({
  ...initialStates,
  fetchInputBasedOnProductType: async () => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    set(() => ({
      inputBasedOnProductTypLoading: FetchState.LOADING,
      inputBasedOnProductTypeData: [],
    }));
    const remoteFetchInputsBasedOnProductType: FetchInputsBasedOnProductType =
      new RemoteFetchInputsBasedOnProductType(
        `${BASE_URL}${Endpoints.FETCH_INPUTS_BASED_ON_PRODUCT_TYPE}`,

        axiosHttpClient
      );
    let params = {
      input_type: get().inputBasedOnProductTypeFilters.inputType,
    };
    let result = await remoteFetchInputsBasedOnProductType.fetch(params);

    if (result.success) {
      set(() => ({ inputBasedOnProductTypeData: result.inputs }));
      set(() => ({ inputBasedOnProductTypLoading: FetchState.SUCCESS }));
    } else {
      Swal.fire({
        icon: "error",
        timer: 3000,
        text: "Error Occured While Fetching Input based on product type",
        customClass: {
          container: "swal2-style",
        },
      });
    }
  },
});
